import {inject, Injectable} from '@angular/core';
import {PlatformService} from "./platform.service";
import {MessageService} from "primeng/api";
import {isNative} from "../utils";

@Injectable({
  providedIn: 'root'
})
export class AppUpdateService {
  private readonly platformService = inject(PlatformService);
  private readonly messageService = inject(MessageService);

  private currentHash: string | undefined;

  public async checkForUpdates() {
    if (this.platformService.isServer || isNative || typeof fetch === 'undefined') {
      return;
    }

    try {
      const response = await fetch(`/version.json?t=${Date.now()}`);

      if (!response.ok) {
        return;
      }

      const data = await response.json();
      const fetchedHash = data.hash;

      if (!fetchedHash) {
        return;
      }

      if (this.currentHash === undefined) {
        this.currentHash = fetchedHash;
        return;
      }

      if (fetchedHash !== this.currentHash) {
        this.messageService.add({
          severity: 'info',
          summary: 'Update available',
          detail: 'New version available. Reloading...',
          sticky: true,
          closable: true,
          life: undefined,
        });

        setTimeout(() => window.location.reload(), 500);
      }
    } catch (error) {
      console.warn('Error checking for updates:', error);
    }
  }
}
